import { createFileRoute } from "@tanstack/react-router";
import { JaziaApp } from "@/components/jazia/JaziaApp";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/sales")({
  beforeLoad: () => {
    requireAuth();
  },
  component: () => <JaziaApp page="sales" />,
});
